import {Route} from '@angular/router';

import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {NoAuthGuard} from 'app/core/auth/guards/noAuth.guard';
import {LayoutComponent} from 'app/layout/layout.component';
import {InitialDataResolver} from 'app/app.resolvers';


// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Path vide = home
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'empty',
            theme: 'theme-brand',
        },
    },

    //
    // Errors
    //
    {
        path: 'error',
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'empty',
            theme: 'theme-brand',
        },
        loadChildren: () => import('app/pages/error/error-500/error-500.module').then(m => m.Error500Module),
    },

    {
        path: 'directLink',

        component: LayoutComponent,

        resolve: {
            initialData: InitialDataResolver,
        },

        data: {
            layout: 'dense',
            theme: 'theme-brand',
        },

        children: [
            {
                path: '',
                loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)
                // loadChildren: () => import('app/modules/direct-link/direct-link.module').then(m => m.DirectLinkModule)
            },

        ]
    },

    // *** SURVEYS ***
    // /survey (accessible aussi bien par les user authentifiés que ceux qui ne le sont pas !
    // Path de l'app [Guest possible : user contributors pas encore signés - Cint etc...]
    //
    {
        path: 'survey',
        // canActivate: [NoAuthGuard, AuthGuard],
        // canActivateChild: [NoAuthGuard, AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'dense',
            theme: 'theme-brand',
        },
        children: [
            //
            // Seule route pour le moment....
            //
            {
                path: '',
                loadChildren: () => import('app/modules/survey/survey.module').then(m => m.SurveyModule)
            },
        ]
    },

    {
        path: 'publication',
        // canActivate: [NoAuthGuard, AuthGuard],
        // canActivateChild: [NoAuthGuard, AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'dense',
            theme: 'theme-brand',
        },
        children: [
            //
            // Seule route pour le moment....
            //
            {
                path: '',
                loadChildren: () => import('app/modules/landing-publication/publication-access.module').then(m => m.PublicationAccessModule)
            },

        ]
    },

    {
        path: 'rewards',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'dense',
            theme: 'theme-brand',
        },
        children: [
            //
            // Seule route pour le moment....
            //
            {
                path: '',
                loadChildren: () => import('app/modules/reward/reward.module').then(m => m.RewardModule)
            },

        ]
    },


    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'home'
    },

    //
    // Auth routes for guests
    //
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)
            },
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
            },
            {
                path: 'reset-password',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)
            },
            {
                path: 'sign-in',
                loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
            },
            {
                path: 'sign-up',
                loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)
            },

        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)
            },
            {
                path: 'unlock-session',
                loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)
            },

        ]
    },

    // Landing routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'dense',
            theme: 'theme-brand',
        },
        children: [
            {
                path: 'home',
                loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)
            },
        ]
    },

    // Admin routes
    // {
    //     path: '',
    //     canActivate: [AuthGuard],
    //     canActivateChild: [AuthGuard],
    //     component: LayoutComponent,
    //     resolve: {
    //         initialData: InitialDataResolver,
    //     },
    //     children: [
    //         {
    //             path: 'example',
    //             loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule)
    //         },
    //         {path: 'survey', loadChildren: () => import('app/modules/survey/survey.module').then(m => m.SurveyModule)},
    //     ]
    // }

    // Redirect empty path to '/example'
    // {
    //
    //     path: '',
    //     pathMatch: 'full',
    //
    //     redirectTo: 'home',
    //
    //     resolve: {
    //       initialData: InitialDataResolver,
    //     },
    //     data: {
    //       layout: 'empty',
    //       theme: 'theme-brand',
    //     },
    //
    // },


];
